import { IconCircleFilled } from '@calendly/ui/components/glyphs/IconCircleFilled';
import { CheckIcon } from '@calendly/ui/components/icons';
import { BareItem } from '@calendly/ui/components/menu';
import { TitleText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorTextAction } from '@calendly/ui/theme';
import { getEventTypeColorToken } from '@calendly/ui/utils/event-type-colors';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { AdminManagedBadge, infoForLocation } from 'components/event_type_edit';
import { Layout } from 'components/layout';
import { CheckboxUI } from '../../../../../../components/checkbox_ui';
const dropdownContainerIsPhoneCss = "d1f38ls";
const dropdownContainerIsV4DesignCss = "d8c8fpl";
const dropdownContainerCss = "dw620s9";
export const DropdownContainer = forwardRef((props, ref) => {
  const {
    isV4Design,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(dropdownContainerCss, {
    [dropdownContainerIsPhoneCss]: isPhone,
    [dropdownContainerIsV4DesignCss]: isV4Design
  }, props.className)} />;
});
const nameDividerCss = "n12elkbw";
export const NameDivider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    children,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(nameDividerCss, props.className)}>
      <TitleText level={3} variant="eyebrow" as="div">{children}</TitleText>
    </Component>;
});
const eventTypeMarkerWithMarginCss = "e1qup9oz";
const eventTypeMarkerCss = "ej3h9pa";
export const EventTypeMarker = forwardRef((props, ref) => {
  const {
    withMargin,
    color,
    ...restProps
  } = props;
  return <div ref={ref} {...restProps} className={classNames(eventTypeMarkerCss, {
    [eventTypeMarkerWithMarginCss]: withMargin
  }, props.className)}>
      <UiIcon icon={IconCircleFilled} color={getEventTypeColorToken(color)} size="small" data-testid="color-dot" />
    </div>;
});
const getLocation = locationConfigurations => {
  if (locationConfigurations?.length) {
    return ` • ${infoForLocation(locationConfigurations[0])}`;
  }
  return null;
};
const EventTypeContent = ({
  color,
  name,
  duration,
  locationConfigurations,
  parentId,
  groupManaged
}) => <Layout gap="8">
    <EventTypeMarker withMargin color={color} />
    <Layout direction="column">
      <span>
        {name}
      </span>
      <span>
        {duration}
        {getLocation(locationConfigurations)}
      </span>
      {parentId && <AdminManagedBadge groupManaged={groupManaged} />}
    </Layout>
  </Layout>;
export const CopyToOption = ({
  onClick,
  selected,
  disabledHint,
  disabled,
  ...props
}) => <BareItem role="option" onClick={onClick} aria-selected={selected ? 'true' : 'false'} {...disabled ? {
  tooltip: {
    placement: 'top',
    text: disabledHint
  }
} : {}} disabled={disabled}>
    <Layout gap="8">
      <CheckboxUI checked={selected} disabled={disabled} />
      <EventTypeContent {...props} />
    </Layout>
  </BareItem>;
export const CopyFromOption = ({
  onClick,
  selected,
  ...props
}) => <BareItem role="option" onClick={onClick} aria-selected={selected ? 'true' : 'false'}>
    <Layout gap="8" justify="space-between" grow>
      <EventTypeContent {...props} />
      {selected && <CheckIcon color={colorTextAction} />}
    </Layout>
  </BareItem>;
const emptyMessageCss = "eavtt4e";
export const EmptyMessage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emptyMessageCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");